module.exports = __webpack_public_path__ + "static/media/richwhitephoto.344b8f45.jpg";